import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthProvider'
import Login from './pages/Login'
import Callback from './pages/Callback'
import CaseStatus from './pages/CaseStatus'
import OnboardingPage from './pages/OnboardingPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  return user ? <>{children}</> : <Navigate to="/" replace />
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/callback" element={<Callback />} />
      {/* Public — protected by single-use onboarding token, no login required */}
      <Route path="/onboard" element={<OnboardingPage />} />
      <Route
        path="/case-status"
        element={
          <ProtectedRoute>
            <CaseStatus />
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
